<template>
    <section class="relative">
         
        <Menu as="div" class="absolute inline text-left z-50 right-0 -mt-16">
            <div>
                <MenuButton
                    class="inline-flex justify-center w-full rounded-md border border-blue-900 shadow-sm px-4 py-2 bg-blue-800 text-sm font-medium text-blue-50 hover:bg-blue-900 focus:outline-none focus:ring-0"
                >
                    {{ t("options", "Opties") }}
                    <ChevronDownIcon
                        class="-mr-1 ml-2 h-5 w-5"
                        aria-hidden="true"
                    />
                </MenuButton>
            </div>

            <transition
                enter-active-class="transition ease-out duration-100"
                enter-from-class="transform opacity-0 scale-95"
                enter-to-class="transform opacity-100 scale-100"
                leave-active-class="transition ease-in duration-75"
                leave-from-class="transform opacity-100 scale-100"
                leave-to-class="transform opacity-0 scale-95"
            >
                <MenuItems
                    class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 focus:outline-none"
                >
                    <div class="px-4 py-3">
                        <p class="text-sm">
                            {{ t("users.selection", "Selectie:") }}
                        </p>
                        <p
                            class="text-sm font-medium text-gray-900 truncate"
                            v-if="users.length > 1"
                        >
                            {{ users.length }}
                            {{ t("users.attendees", "deelnemers") }}
                        </p>
                        <p
                            class="text-sm font-medium text-gray-900 truncate"
                            v-if="users.length == 1"
                        >
                            {{ users[0]["name"] }}
                        </p>
                    </div>
                    <div class="py-1" v-if="list == 'active'">
                        <MenuItem v-slot="{ active }">
                            <p
                                @click="actionForSelection('send-invite')"
                                class="cursor-pointer"
                                :class="[
                                    active
                                        ? 'bg-gray-100 text-gray-900'
                                        : 'text-gray-700',
                                    'block px-4 py-2 text-sm',
                                ]"
                            >
                                {{
                                    t("users.send-invite", "Stuur uitnodiging")
                                }}
                            </p>
                        </MenuItem>
                    </div>
                    <div class="py-1">
                        <MenuItem v-slot="{ active }" v-if="list == 'active'">
                            <button
                                @click="actionForSelection('revoke-access')"
                                :class="[
                                    active
                                        ? 'bg-gray-100 text-gray-900'
                                        : 'text-gray-700',
                                    'block w-full text-left px-4 py-2 text-sm',
                                ]"
                            >
                                {{
                                    t(
                                        "users.revoke-access",
                                        "Toegang ontzeggen"
                                    )
                                }}
                            </button>
                        </MenuItem>
                        <MenuItem v-slot="{ active }" v-if="list == 'inactive'">
                            <button
                                @click="actionForSelection('give-access')"
                                :class="[
                                    active
                                        ? 'bg-gray-100 text-gray-900'
                                        : 'text-gray-700',
                                    'block w-full text-left px-4 py-2 text-sm',
                                ]"
                            >
                                {{ t("users.give-access", "Toegang geven") }}
                            </button>
                        </MenuItem>
                        <MenuItem v-slot="{ active }">
                            <button
                                @click="actionForSelection('deleting')"
                                :class="[
                                    active
                                        ? 'bg-gray-100 text-gray-900'
                                        : 'text-gray-700',
                                    'block w-full text-left px-4 py-2 text-sm',
                                ]"
                            >
                                {{ t("users.delete", "Verwijderen") }}
                            </button>
                        </MenuItem>
                    </div>
                </MenuItems>
            </transition>
        </Menu>
    </section>
</template>

<script>
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
import { ChevronDownIcon } from "@heroicons/vue/solid";
import Swal from "sweetalert2";
export default {
    components: {
        Menu,
        MenuButton,
        MenuItem,
        MenuItems,
        ChevronDownIcon,
    },
    props: ["users", "list", "meetings"],
    methods: {
        actionForSelection(_action) {
            let self = this;
            var users = [];
            this.users.forEach(function (obj) {
                users.push(obj.id);
            });
            // var title = "Let op";
            // var text = "Zeker weten dat je de selectie wilt ";

            var title = self.t("users.actions.title", "Let op"); // "Let op";
            var text = self.t(
                "users.actions.are-you-sure-selection",
                "Zeker weten dat je de selectie wilt "
            ); //"Zeker weten: ";

            var action = _action;
            switch (_action) {
                case "deleting":
                    action = "verwijderen";
                    action = self.t(
                        "users.actions.action-deleting",
                        "verwijderen"
                    );
                    break;
                case "send-invite":
                    action = "uitnodigen";
                    action = self.t(
                        "users.actions.action-send-invite",
                        "uitnodigen"
                    );
                    break;
                case "give-access":
                    action = "activeren";
                    action = self.t(
                        "users.actions.action-give-access",
                        "activeren"
                    );
                    break;
                case "revoke-access":
                    action = "blokkeren";
                    action = self.t(
                        "users.actions.action-revoke-access",
                        "blokkeren"
                    );
                    break;
                default:
                    break;
            }
            console.info(self.meetings);

            Swal.fire({
                title: title,
                text: text + " " + action + "?",
                icon: "warning",
                input: _action == "send-invite" ? "select" : null,
                inputOptions: self.meetings,
                showCancelButton: true,
                confirmButtonColor: "#de3618",
                cancelButtonColor: "#333",
                confirmButtonText: self.t("tts.yes"),
                cancelButtonText: self.t("tts.cancel"),
            }).then((result) => {
                if (result.value) {
                    axios
                        .post("/api/multiple-users", {
                            users: users,
                            action: _action,
                            value: result.value,
                        })
                        .then((response) => {
                            Eventing.fire("notify", {
                                title: self.capitalize(action),
                                message: self.t(
                                    "users.actions.succeeded",
                                    "Actie succesvol uitgevoerd"
                                ),
                                type: "success",
                                position: "center",
                            });
                            Eventing.fire("fetchUsers");
                        })
                        .catch((error) => {});
                }
            });
        },
        capitalize(s) {
            return s[0].toUpperCase() + s.slice(1);
        },
    },
};
</script>
